import { render, staticRenderFns } from "./routeProductRevenueStatistics.vue?vue&type=template&id=0f84aa80&"
import script from "./routeProductRevenueStatistics.vue?vue&type=script&lang=js&"
export * from "./routeProductRevenueStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f84aa80')) {
      api.createRecord('0f84aa80', component.options)
    } else {
      api.reload('0f84aa80', component.options)
    }
    module.hot.accept("./routeProductRevenueStatistics.vue?vue&type=template&id=0f84aa80&", function () {
      api.rerender('0f84aa80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/routeProductRevenueStatistics.vue"
export default component.exports